module.exports = __webpack_public_path__ + "static/media/decor-scop-work2.a12e14b2.png";